export default {
  namespaced: true,
  weekdaysObj: {
    monday: { title: 'Thứ Hai', value: 'monday', index: 1 },
    tuesday: { title: 'Thứ Ba', value: 'tuesday', index: 2 },
    wednesday: { title: 'Thứ Tư', value: 'wednesday', index: 3 },
    thursday: { title: 'Thứ Năm', value: 'thursday', index: 4 },
    friday: { title: 'Thứ Sáu', value: 'friday', index: 5 },
    saturday: { title: 'Thứ Bảy', value: 'saturday', index: 6 },
  },
  defaultFactors: [
    {
      title: 'Điểm đánh giá thường xuyên (HS1)',
      index: 0,
      quantity: 8,
      multiply: 1,
      type: 'factor-1',
    },
    {
      title: 'Điểm đánh giá giữa kỳ (HS2)',
      index: 1,
      quantity: 1,
      multiply: 2,
      type: 'factor-2',
    },
    {
      title: 'Điểm đánh giá cuối kỳ (HS3)',
      index: 2,
      quantity: 1,
      multiply: 3,
      type: 'factor-3',
    },
  ],
  state: {
    leadStatus: [
      {
        title: 'Đã xác nhận',
        status: 'running',
      },
      {
        title: 'Đã Thu Tiền',
        status: 'paid',
      },
      {
        title: 'Đã xếp lớp',
        status: 'Done',
      },
      {
        title: 'Còn Nợ',
        status: 'liabilities',
      },
      {
        title: 'Đã Hủy',
        status: 'canceled',
      },
    ],
    leadState: [
      {
        title: 'Chưa Duyệt',
        status: 'under-approval',
      },
      {
        title: 'Đã Duyệt',
        status: 'approved',
      },
    ],
    leadTypes: [
      {
        title: 'Học Phí',
        status: 'tuition',
      },
      {
        title: 'Thu nợ',
        status: 'other',
      },
      {
        title: 'Khác',
        status: 'other',
      },
      {
        title: 'Dịch Vụ',
        status: 'services',
      },
    ],
    billStatus: [
      {
        title: 'Đã Thu Tiền',
        status: 'paid',
      },
      {
        title: 'Bị Từ Chối',
        status: 'rejected',
      },
      {
        title: 'Còn Nợ',
        status: 'liabilities',
      },
      {
        title: 'Đã Hủy',
        status: 'canceled',
      },
    ],
    facilityStatus: [
      {
        title: 'Quá Hạn',
        status: 'over-due',
      },
      {
        title: 'Hỏng',
        status: 'broken',
      },
      {
        title: 'Đã Bán',
        status: 'paid',
      },
      {
        title: 'Đang Mượn',
        status: 'using',
      },
      {
        title: 'Trong Kho',
        status: 'inventory',
      },
    ],
    bookStatus: [
      {
        title: 'Quá Hạn',
        status: 'over-due',
      },
      {
        title: 'Hỏng',
        status: 'broken',
      },
      {
        title: 'Đã Bán',
        status: 'paid',
      },
      {
        title: 'Đang Mượn',
        status: 'using',
      },
      {
        title: 'Trong Kho',
        status: 'inventory',
      },
    ],
    facilityTypes: [
      {
        title: 'Sách',
        status: 'book',
      },
      {
        title: 'Trang Thiết Bị',
        status: 'device',
      },
      {
        title: 'CSVC Cố Định',
        status: 'fixed-facility',
      },
      {
        title: 'Học Liệu',
        status: 'material',
      },
    ],
    bookTypes: [
      {
        title: 'Sách',
        status: 'book',
      },
      {
        title: 'Trang Thiết Bị',
        status: 'device',
      },
      {
        title: 'CSVC Cố Định',
        status: 'fixed-facility',
      },
      {
        title: 'Học Liệu',
        status: 'material',
      },
    ],
    productStatus: [
      {
        title: 'Hết Hàng',
        status: 'out-of-stock',
      },
      {
        title: 'Đang Kinh Doanh',
        status: 'active',
      },
      {
        title: 'Ngừng Kinh Doanh',
        status: 'block',
      },
    ],
    paymentTypes: [
      {
        title: 'Tiền mặt',
        status: 'cash',
      },
      {
        title: 'Chuyển Khoản',
        status: 'bank',
      },
      {
        title: 'Trả Góp',
        status: 'installment',
      },
      {
        title: 'Quẹt thẻ',
        status: 'card',
      },
    ],
    productTypes: [
      {
        title: 'Tiền mặt',
        status: 'cash',
      },
      {
        title: 'Chuyển Khoản',
        status: 'bank',
      },
      {
        title: 'Trả Góp',
        status: 'installment',
      },
      {
        title: 'Quẹt thẻ',
        status: 'card',
      },
    ],
    slotStatus: [
      {
        title: 'Chờ điểm danh',
        status: 'opened',
      },
      {
        title: 'Đã điểm danh',
        status: 'running',
      },
      {
        title: 'Kết thúc',
        status: 'Done',
      },
      {
        title: 'Bị Từ Chối',
        status: 'rejected',
      },
      {
        title: 'Đã Hủy',
        status: 'canceled',
      },
    ],
    slotTypes: [
      {
        title: 'Lớp Học',
        status: 'class-slot',
        // },{
        //   'title': 'Sự Kiện',
        //   'status': 'event-slot'
        // },{
        //   'title': 'Trực Cơ Sở',
        //   'status': 'monitoring-slot'
      },
      {
        title: 'Dạy Bù',
        status: 'recovery-slot',
        // },{
        //   'title': 'Giám Khảo',
        //   'status': 'examiner-slot'
        // },{
        //   'title': 'Thuyết Trình',
        //   'status': 'presentation-slot'
        // },{
        //   'title': 'Hackathon',
        //   'status': 'hackathon-slot'
      },
    ],
    attendanceStatus: [
      {
        title: 'Chưa điểm danh',
        status: 'none',
      },
      {
        title: 'Vắng mặt',
        status: 'absent',
      },
      {
        title: 'Có mặt',
        status: 'attended',
      },
      // {
      //   title: 'Đi Muộn',
      //   status: 'late'
      // },
      // {
      //   title: 'Đúng giờ',
      //   status: 'onTime'
      // }
    ],
    diligenceStatus: [
      {
        title: 'Có phép',
        status: 'yes',
      },
      {
        title: 'Không phép',
        status: 'no',
      },
    ],

    attendanceStates: [
      {
        title: 'Từ Chối',
        status: 'rejected',
      },
      {
        title: 'Chờ Xác Nhận',
        status: 'wait',
      },
      {
        title: 'Chờ Xác Nhận',
        status: '',
      },
      {
        title: 'Xác Nhận',
        status: 'confirmed',
      },
      {
        title: 'Đã Trả Lương',
        status: 'paid',
      },
    ],
    attendanceTypes: [
      {
        title: 'Giáo Viên',
        status: 'teacher-attendance',
      },
      {
        title: 'Trợ Giảng',
        status: 'mentor-attendance',
      },
      {
        title: 'Học Sinh',
        status: 'student-attendance',
      },
    ],
    classStatus: [
      {
        title: 'Đang chờ',
        status: 'opened',
      },
      {
        title: 'Đang chạy',
        status: 'running',
      },
      {
        title: 'Kết Thúc',
        status: 'done',
      },
    ],
    busStatus: [
      {
        title: 'Đang hoạt động',
        status: 'active',
      },
      {
        title: 'Đã ngưng',
        status: 'inactive',
      },
    ],
    studentStatus: [
      {
        title: 'Đang học',
        status: 'active',
      },
      {
        title: 'Bảo lưu',
        status: 'reserved',
      },
      // {
      //   title: 'Đã tốt nghiệp',
      //   status: 'graduated'
      // },
      {
        title: 'Đã nghỉ',
        status: 'left',
      },
    ],
    billTypes: [
      {
        title: 'Học Phí',
        status: 'tuition',
      },
      {
        title: 'Thu nợ',
        status: 'liability',
      },
      {
        title: 'Bán Hàng',
        status: 'product',
      },
      {
        title: 'Khác',
        status: 'other',
      },
    ],
    showcasePositions: [
      {
        title: 'Đầu trang',
        status: 'home-page',
      },
      {
        title: 'Ảnh đại diện',
        status: 'highlight',
      },
    ],
    postTypes: [
      {
        title: 'Thông báo',
        value: 'notification',
      },
      {
        title: 'Điểm số',
        value: 'mark',
      },
      {
        title: 'Ghi chú cần theo dõi',
        value: 'violation',
      },
      {
        title: 'Học phí',
        value: 'tuitionFee',
      },
      {
        title: 'Chuyên cần',
        value: 'diligence',
      },
      {
        title: 'Thời khóa biểu',
        value: 'schedule',
      },
      {
        title: 'Học tập online',
        value: 'onlineStudy',
      },
      {
        title: 'Bài tập về nhà',
        value: 'homework',
      },
      {
        title: 'Khác',
        value: 'other',
      },
    ],
    smsStatuses: [
      {
        title: 'Thành công',
        value: 'success',
      },
      {
        title: 'Gửi lỗi',
        value: 'error',
      },
    ],
    postToTypes: [
      {
        title: 'Toàn trung tâm',
        value: 'school',
      },
      {
        title: 'Học phần',
        value: 'grade',
      },
      {
        title: 'Lớp',
        value: 'class',
      },
      {
        title: 'Học viên',
        value: 'student',
      },
    ],
    postConfigs: [
      {
        title: 'Soạn riêng',
        value: 'immediately',
      },
      {
        title: 'Tự động',
        value: 'auto',
      },
    ],
    busDirections: [
      { value: 'morningToSchool', title: 'Đến trung tâm buổi sáng' },
      { value: 'morningFromSchool', title: 'Rời trung tâm buổi sáng' },
      { value: 'afternoonToSchool', title: 'Đến trung tâm buổi chiều' },
      { value: 'afternoonFromSchool', title: 'Rời trung tâm buổi chiều' },
    ],
    subjectTypes: [
      { value: 'coreCurriculum', title: 'Chính khoá' },
      { value: 'extraCurriculum', title: 'Bổ trợ' },
    ],
    teacherStatus: [
      { title: 'Đang dạy', value: 'active' },
      { title: 'Tạm nghỉ', value: 'pause' },
      { title: 'Đã nghỉ', value: 'left' },
    ],
    roleConfigs: [
      { title: 'Chương trình', value: 'advance' },
      { title: 'Học viên', value: 'student' },
      { title: 'Giáo viên', value: 'teacher' },
      { title: 'Công việc', value: 'task' },
      { title: 'Lớp học', value: 'class' },
      { title: 'Thời khóa biểu', value: 'schedule' },
      // { title: 'Thời khóa biểu*', value: 'schedule-draft' },
      { title: 'Thông báo', value: 'contactBook' },
      // { title: 'Phản hồi', value: 'feedback' },
      // { title: 'Hồ sơ sổ sách', value: 'document' },
      { title: 'Sổ sách giáo viên', value: 'teacherDoc' },
      // { title: 'Nhân viên', value: 'staff' },
      { title: 'Tài chính', value: 'finance' },
      // { title: 'Quỹ xu', value: 'balance' },
      // { title: 'Lương giáo viên', value: 'salary' },
      // { title: 'Xe tuyến', value: 'bus' },
      // { title: 'Dịch vụ bếp', value: 'dishService' },
      { title: 'Quản trị hệ thống', value: 'setting' },
    ],
    messageMemberType: {
      parentTeacher: 'parent-teacher',
      parentTeacherManager: 'parent-teacher-manager',
    },
    weekdays: [
      { title: 'Thứ Hai', value: 'monday', index: 1 },
      { title: 'Thứ Ba', value: 'tuesday', index: 2 },
      { title: 'Thứ Tư', value: 'wednesday', index: 3 },
      { title: 'Thứ Năm', value: 'thursday', index: 4 },
      { title: 'Thứ Sáu', value: 'friday', index: 5 },
      { title: 'Thứ Bảy', value: 'saturday', index: 6 },
    ],
    busTimelines: [
      { title: 'Đến trung tâm buổi sáng', value: 'AM-in' },
      { title: 'Rời trung tâm buổi sáng', value: 'AM-out' },
      { title: 'Đến trung tâm buổi chiều', value: 'PM-in' },
      { title: 'Rời trung tâm buổi chiều', value: 'PM-out' },
    ],
    busAttendanceStatus: [
      {
        title: 'Chưa bắt đầu',
        value: 'not-start',
      },
      {
        title: 'Đang di chuyển',
        value: 'running',
      },
      {
        title: 'Đã hoàn thành',
        value: 'finished',
      },
    ],
    busStudentAttendanceStatus: [
      {
        title: 'Chưa lên xe',
        value: 'not-checkin',
      },
      {
        title: 'Vắng mặt',
        value: 'absent',
      },
      {
        title: 'Đã lên xe',
        value: 'attendance',
      },
      {
        title: 'Chưa xuống xe',
        value: 'not-left',
      },
      {
        title: 'Đã xuống xe',
        value: 'left',
      },
      {
        title: 'Khác',
        value: 'other',
      },
    ],
    busStudentCheckinStatus: [
      {
        title: 'Chưa lên xe',
        value: 'notCheckin',
      },
      {
        title: 'Vắng mặt',
        value: 'absent',
      },
      {
        title: 'Đã lên xe',
        value: 'attendance',
      },
      {
        title: 'Chưa xuống xe',
        value: 'notLeft',
      },
      {
        title: 'Đã xuống xe',
        value: 'left',
      },
      {
        title: 'Khác',
        value: 'other-attendance',
      },
    ],
    // busStudentCheckoutStatus: [
    //   {
    //     title: 'Chưa xuống xe',
    //     value: 'not-left'
    //   },
    //   {
    //     title: 'Đã xuống xe',
    //     value: 'left'
    //   },
    //   {
    //     title: 'Khác',
    //     value: 'other-left'
    //   }
    // ],
    senderMethods: [
      { type: 'auto', title: 'Tất cả (Tự động theo đăng ký, ưu tiên App)' },
      { type: 'sms', title: 'Tất cả (Theo SMS)' },
      { type: 'app', title: 'Đang sử dụng App' },
      { type: 'sms-only', title: 'Chỉ sử dụng SMS' }, // chỉ sử dụng sms mà k sử dụng app
    ],
    dishTypes: [
      { value: 'main', title: 'Món chính' },
      { value: 'side', title: 'Món phụ' },
    ],
    menus: [
      { value: 'menu1', title: 'Thực đơn 1' },
      { value: 'menu2', title: 'Thực đơn 2' },
      { value: '0', title: 'Không đăng ký' },
    ],
    mealTransferStatuses: [
      { value: 'not-eat', title: 'Chưa ăn' },
      { value: 'ate', title: 'Đã ăn' },
      { value: 'not-receive', title: 'Không ăn' },
      { value: 'validCancel', title: 'Hủy hợp lệ' },
    ],
    mealAmountList: [
      { value: 0, title: '0' },
      { value: 1, title: '1' },
      { value: 2, title: '2' },
      { value: 3, title: '3' },
    ],
    autoSendAttendanceMessageStatuses: [
      { value: 'disable', title: 'Tắt' },
      { value: 'enable', title: 'Bật' },
    ],
  },
  getters: {
    slotStatus: (state) => (filter) => {
      return state.slotStatus.filter(filter)
    },
    billStatus: (state) => state.billStatus,
    paymentTypes: (state) => state.paymentTypes,
    productTypes: (state) => state.productTypes,
    productStatus: (state) => state.productStatus,
    showcasePositions: (state) => state.showcasePositions,
    postTypes: (state) => state.postTypes,
    smsStatuses: (state) => state.smsStatuses,
    postToTypes: (state) => state.postToTypes,
    postConfigs: (state) => state.postConfigs,
    subjectTypes: (state) => state.subjectTypes,
    teacherStatus: (state) => state.teacherStatus,
    roleConfigs: (state) => state.roleConfigs,
    messageMemberType: (state) => state.messageMemberType,
    weekdays: (state) => state.weekdays,
    busTimelines: (state) => state.busTimelines,
    busStudentAttendanceStatus: (state) => state.busStudentAttendanceStatus,
    busStudentCheckinStatus: (state) => state.busStudentCheckinStatus,
    busStudentCheckoutStatus: (state) => state.busStudentCheckoutStatus,
    busAttendanceStatus: (state) => state.busAttendanceStatus,
    senderMethods: (state) => state.senderMethods,
    dishTypes: (state) => state.dishTypes,
    menus: (state) => state.menus,
    mealTransferStatuses: (state) => state.mealTransferStatuses,
    mealAmountList: (state) => state.mealAmountList,
    autoSendAttendanceMessageStatuses: (state) => state.autoSendAttendanceMessageStatuses,
  },
}
